<template>
    <div class="row">
        <div class="col-md-3">
            <b-card no-body class="p-1">
                <div class="row">
                    <div class="col-12 mb-1">
                        <label class="form-label">Kasa</label>
                        <v-validator :errors="errors" parameter="VaultCode" :watch="kasa">
                            <v-select-list   v-model="kasa" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
                        </v-validator>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Kimlik Numarası</label>
                        <v-validator :errors="errors" parameter="IdentityNumber" :watch="model.IdentityNumber">
                            <input type="number" v-model="model.IdentityNumber" class="form-control" placeholder="Kimlik Numarası"/>
                        </v-validator>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Tutar (TL)</label>
                        <v-validator :errors="errors" parameter="IdentityNumber" :watch="model.IdentityNumber">
                            <v-currency-input input-class="text-right" :value="model.Amount" v-on:update-value="currencyAmount => model.Amount = currencyAmount"></v-currency-input>
                        </v-validator>
                    </div>
                    <div class="col-12 text-right">
                        <v-executer :action="send" :loading="sending">Kaydet</v-executer>
                    </div>
                </div>
            </b-card>
        </div>
        <div class="col-md-9"></div>
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VValidator from '@/components/VValidator.vue';
import NetsisOperationsApi from '@/api/netsis-operations'
import VCurrencyInput from '@/components/VCurrencyInput.vue';
import NetsisAccountantApi from '@/api/netsis-accountant'

export  default {
    components:{
        BCard,
        VValidator,
        VCurrencyInput
    },
    data(){
        return {
            kasaLoading:false,
            kasaList:[],
            errors:{},
            model:{
                IdentityNumber: null,
                Amount: 0,
                VaultCode: null
            },
            sending:false
        }
    },
    mounted(){
        this.getKasaList()
    },
    methods:{
        clearForm(){
            this.model.IdentityNumber = null
            this.model.Amount = 0
            this.model.VaultCode = null
        },
        getKasaList(){
            this.kasaLoading = true
            NetsisOperationsApi.GetKasaList().then(res => {
                this.kasaList = res.data.Data
                this.kasaLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaLoading = false
            })
        },
        send(){
            this.sending = true
            NetsisAccountantApi.GAvans.Assign(this.model).then(res => {
                this.$result(res)
                this.sending = false
                if(res.data.Success){
                    this.clearForm()
                }
            }).catch(err => {
                this.$result(null,err)
                this.sending = false
            })
        }
    },
    computed:{
        kasa:{
            get:function(){
                return this.kasaList.find(s=>s.KSMAS_KOD==this.model.VaultCode)
            },
            set:function(value){
                this.model.VaultCode = value?.KSMAS_KOD || null
            }
        }
    }
}
</script>